import React, { useContext, useState } from 'react';
import ButtonIcon from "../../../../CommonElements/ButtonIcon";
import WalletContext from "../Context";
import AuthorizationContext from "../../../../_helper/Authorization";
import type { AuthorizationContextType } from "../../../../_helper/Authorization/AuthorizationTypes";
import type { WalletContextType } from "../Context/WalletContext.types";
import Loader from "../../../../Layout/Loader";

interface AdminZoneWalletProps {
    relationKey: string;
    relationId: string | number;
    onSuccess?: () => void;
}

const AdminZoneWallet: React.FC<AdminZoneWalletProps> = ({
    relationKey,
    relationId,
    onSuccess
}) => {
    const [loaderVisibility, setLoaderVisibility] = useState<boolean>(false);
    const walletContext = useContext(WalletContext) as WalletContextType;
    const authContext = useContext(AuthorizationContext) as AuthorizationContextType;
    const { errorHandler, hasPermission } = authContext || {};
    const { createPendingWallets } = walletContext || {};

    const createWallets = () => {
        if (!createPendingWallets) return;
        setLoaderVisibility(true);
        createPendingWallets(
            relationKey,
            relationId,
            () => {
                setLoaderVisibility(false);
                if (onSuccess) {
                    onSuccess();
                }
            },
            (exception: any) => {
                if (errorHandler) {
                    errorHandler(exception);
                }
                setLoaderVisibility(false);
            }
        );
    };

    // Check if user has permission to create wallets
    const hasCreateWalletPermission = !!(hasPermission && hasPermission('create-wallet'));

    if (!hasCreateWalletPermission) {
        return null;
    }

    return (
        <>
            <Loader visibility={loaderVisibility} />
            <div className='social-network theme-form m-b-20'>
                <span className='f-w-600 text-primary'>Admin Zone</span>
                <ButtonIcon 
                    confirm={{
                        confirm: true,
                        text: 'Are you sure you want to create unavailable wallets'
                    }} 
                    onclick={() => createWallets()} 
                    type={'confirm'}
                />
            </div>
        </>
    );
};

export default AdminZoneWallet;

